<template>
  <div
    class="flex items-center md:items-baseline"
    @click.stop.prevent="checkThat"
  >
    <p
      :for="name"
      v-if="libelle != null && libelle != undefined && isCheckboxRight"
      :class="
        sizeLibelle +
        ' ' +
        (mutableValue ? colorLibelle : 'text-gray-600') +
        ' ' +
        weightLibelle +
        ' pr-2 py-1 inline-block cursor-default'
      "
    >
      {{ libelle }}
    </p>

    <div class="relative flex items-center justify-center top-1">
      <input
        v-if="isArray"
        :name="name"
        type="checkbox"
        v-model="isArray"
        :value="name"
        class="appearance-none bg-opacity-25 h-indigo-checkbox w-indigo-checkbox focus:outline-none focus:outline-indigo border-2 rounded"
        :class="
          (disabled || disabled_pass) && !mutableValue
            ? 'bg-gray-200 border-gray-600 cursor-not-allowed'
            : mutableValue || hasPartly
            ? colorBorder + ' ' + colorChecked
            : colorBorder + ' ' + colorUnchecked
        "
        :necessary="progressCount"
        :disabled="disabled || disabled_pass"
      />
      <input
        :name="name"
        type="checkbox"
        v-model="mutableValue"
        :class="
          'appearance-none focus:outline-none focus:outline-indigo border rounded' +
          ((disabled || disabled_pass) && !mutableValue
            ? ' bg-gray-200 border-gray-600 cursor-not-allowed'
            : mutableValue || hasPartly
            ? ' ' + colorChecked + ' ' + colorBorder
            : ' ' + colorUnchecked + ' ' + colorBorder) +
          (isSmall ? ' h-3.5 w-3.5' : ' h-indigo-checkbox w-indigo-checkbox')
        "
        :necessary="progressCount"
        :disabled="disabled || disabled_pass"
      />

      <div class="pointer-events-none absolute">
        <icon
          name="checkmark"
          width="12px"
          height="8px"
          class="text-white"
          v-if="mutableValue && !isSmall"
        />
        <icon
          name="checkmark"
          width="8px"
          height="5px"
          class="text-white"
          v-if="mutableValue && isSmall"
        />
        <icon
          name="minus"
          width="12px"
          height="8px"
          class="text-white"
          v-if="!mutableValue && hasPartly && !isSmall"
        />
        <icon
          name="minus"
          width="8px"
          height="5px"
          class="text-white"
          v-if="!mutableValue && hasPartly && isSmall"
        />
      </div>
    </div>

    <p
      :for="name"
      v-if="libelle != null && libelle != undefined && !isCheckboxRight"
      :class="
        sizeLibelle +
        ' ' +
        colorLibelle +
        ' ' +
        weightLibelle +
        ' pl-2 py-1 inline-block cursor-default'
      "
    >
      {{ libelle }}
    </p>
  </div>
</template>

<script>
import Icon from '../../components/Icon';

export default {
  components: {
    Icon,
  },

  props: {
    name: String,
    libelle: String,
    value: Boolean,
    necessary: Boolean,
    isArray: {
      type: Boolean,
      required: false,
      default: false,
    },
    colorLibelle: {
      type: String,
      required: false,
      default: 'text-gray-900',
    },
    sizeLibelle: {
      type: String,
      required: false,
      default: 'text-base',
    },
    weightLibelle: {
      type: String,
      required: false,
      default: 'font-normal',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    isCheckboxRight: {
      type: Boolean,
      required: false,
      default: false,
    },
    itemList: {
      type: Array,
      required: false,
    },
    selectedItems: {
      type: Array,
      required: false,
    },
    isSmall: {
      type: Boolean,
      required: false,
      default: false,
    },
    forceActiveInNeopassForm: {
      type: Boolean,
      required: false,
      default: false,
    },
    colorBorder: {
      type: String,
      required: false,
      default: 'border-indigo-600',
    },
    colorChecked: {
      type: String,
      required: false,
      default: 'bg-indigo-600',
    },
    colorUnchecked: {
      type: String,
      required: false,
      default: 'bg-white',
    },
    notClickToFalse: {
      type: Boolean,
      required: false,
      default: false,
    },
    hasPartly: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  data: function () {
    return {
      mutableValue: this.value != undefined ? this.value : false,
      progressCount: true,
      disabled_pass: false,
    };
  },
  mounted() {
    // Manage edit permission for neopass pages
    if (
      this.$route.path.includes('form/neopass') &&
      !this.forceActiveInNeopassForm
    ) {
      let idpass = this.$route.path.split('/form/neopass/')[1].split('/')[0];
      let page = this.$route.path.split('/form/neopass/')[1].split('/')[2];
      if (this.$can(page + '_edit', idpass)) {
        this.disabled_pass = false;
      } else {
        this.disabled_pass = true;
      }
    } else {
      this.disabled_pass = false;
    }

    //assign "necessary" prop value to "progressCount" data if this prop is filled
    if (this.necessary != undefined && !this.necessary) {
      this.progressCount = false;
    }
  },
  methods: {
    checkThat() {
      if (!this.disabled) {
        if (!this.mutableValue || !this.notClickToFalse) {
          this.mutableValue = !this.mutableValue;
        }
        this.$emit('input', this.mutableValue);
        if (this.selectedItems !== undefined && this.itemList !== undefined) {
          if (this.selectedItems.length === this.itemList.length) {
            this.value = false;
            this.mutableValue = false;
          } else {
            this.value = true;
            this.mutableValue = true;
          }
        }
      }
    },
  },
  watch: {
    value() {
      this.mutableValue = this.value;
    },
  },
};
</script>
